import React from "react";
import Select, { components } from "react-select";
import { FaCaretDown } from "react-icons/fa";
import { MdOutlineArrowDropDown } from "react-icons/md";
import { useFormContext } from "react-hook-form";
import get from "lodash/get";
import { useLocation } from "react-router-dom";
import { EMPTY_STRING, SCREEN_PATH } from "../../../constants";
import { customStyles } from "../ReactSelect/CustomStyles";

const DropdownIndicator = (props) => {
  const { pathname } = useLocation();
  const Icon =
    pathname === SCREEN_PATH.MY_PROFILE ||
    pathname === SCREEN_PATH.AGENT_PROFILE
      ? FaCaretDown
      : MdOutlineArrowDropDown;
  const color =
    pathname === SCREEN_PATH.MY_PROFILE ||
    pathname === SCREEN_PATH.AGENT_PROFILE
      ? "white"
      : "black";

  return (
    <components.DropdownIndicator {...props}>
      <Icon color={color} />
    </components.DropdownIndicator>
  );
};

const CustomSelect = ({
  placeholder = EMPTY_STRING,
  name = EMPTY_STRING,
  options,
  isMulti = false,
  isEditing = false,
  className = EMPTY_STRING,
  isClearable,
  showError = true,
  getOptionLabel = (option) => option.label,
  getOptionValue = (option) => option.value,
  defaultStyle = true,
  customDropDown = true,
  readOnly = false,
  renderedValuesClass = EMPTY_STRING,
  commaSeparatedMultiValue = true,
  customHandleChange = () => {},
  isBorderRadius = false,
}) => {
  const { pathname } = useLocation();
  const {
    setValue,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();
  const selectedValue = watch(name);

  const getValue = () => {
    if (isMulti) {
      return options.filter((option) =>
        (selectedValue ?? []).includes(Number(option.value))
      );
    } else {
      if (
        typeof selectedValue === "boolean" &&
        !options.find((option) => typeof option.value === "boolean")
      ) {
        let tempSelectedValue = selectedValue ? 1 : 0;
        return (
          options.find((option) => option.value === tempSelectedValue) || null
        );
      } else {
        return options.find((option) => option.value === selectedValue) || null;
      }
    }
  };

  const handleChange = (val) => {
    customHandleChange();
    setValue(
      name,
      isMulti
        ? val
          ? val.map((option) => Number(option.value))
          : []
        : val
        ? val.value
        : null
    );
    trigger(name);
  };

  const renderMultiValues = () =>
    getValue().map((option, index) =>
      commaSeparatedMultiValue ? (
        option.label + (index < getValue().length - 1 ? ", " : EMPTY_STRING)
      ) : (
        <div>{option.label}</div>
      )
    );

  const errorMessage = get(errors, name)?.message;

  return (
    <>
      {pathname === SCREEN_PATH.CREATE_LISTING ||
      isEditing ||
      pathname.includes(SCREEN_PATH.MY_LISTING) ? (
        <>
          <Select
            options={options}
            className={`${
              pathname === SCREEN_PATH.CREATE_LISTING ||
              pathname.includes(SCREEN_PATH.MY_LISTING)
                ? `create-list-input select-input ${className}`
                : className
            }`}
            name={name}
            value={getValue()}
            onChange={handleChange}
            placeholder={placeholder}
            components={{
              ...(customDropDown
                ? { DropdownIndicator: DropdownIndicator }
                : {}),
            }}
            isClearable={
              isClearable ??
              (pathname !== SCREEN_PATH.CREATE_LISTING &&
                !pathname.includes(SCREEN_PATH.MY_LISTING))
            }
            isMulti={isMulti}
            styles={customStyles(defaultStyle, !!errorMessage, isBorderRadius)}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            isDisabled={readOnly}
          />
          {showError && errorMessage && (
            <div className="error mt-2">{errorMessage}</div>
          )}
        </>
      ) : (
        <div className={renderedValuesClass}>
          {isMulti ? renderMultiValues() : getValue()?.label ?? "N/A"}
        </div>
      )}
    </>
  );
};

export default CustomSelect;
